import { WppTypography } from '@platform-ui-kit/components-library-react'

import styles from 'layout/header/breadcrumbs/common/separator/BreadcrumbsSeparator.module.scss'

export const BreadcrumbsSeparator = () => (
  <WppTypography className={styles.separator} type="s-body">
    /
  </WppTypography>
)
